import type {Changeset} from '@microsoft/agent-host-protocol'
import {sessionChannel} from '@github-ui/ahp-relay/relay-connection-runtime'
import type {TaskHistorySession} from './replay-task-history-events'

export function findSavedChangesetUri(saved: TaskHistorySession | undefined): string | undefined {
  const catalogue = saved?.bundle.sessionState.changesets
  return catalogue !== undefined || saved?.bundle.changesetCatalogIsAuthoritative
    ? findSessionChangesetUri(catalogue, saved?.sessionId)
    : Object.keys(saved?.bundle.changesetStates ?? {})[0]
}

/** Prefer all, then session, then the first static catalogue entry. Never infer kinds from opaque URIs. */
export function findSessionChangesetUri(
  changesets: readonly Changeset[] | undefined,
  sessionId: string | undefined,
): string | undefined {
  const entries = changesets?.filter(entry => !entry.uriTemplate.includes('{')) ?? []
  const entry =
    ['all', 'session'].map(kind => entries.find(candidate => candidate.changeKind === kind)).find(Boolean) ?? entries[0]
  const template = entry?.uriTemplate
  if (!template) return undefined
  if (URL.canParse(template) || template.startsWith('/')) return template
  return sessionId ? `${sessionChannel(sessionId)}/${template}` : undefined
}
